export default __webpack_public_path__ + "media/images/phone-f40e5d52e39b5281a2b6e0777c2acf58.png";